import React, { useState, useEffect } from 'react';
import RichTable from '../components/richTable/RichTable.jsx'
import tableHelpers from '../helpers/TableHelpers.js'
import { Link } from 'react-router-dom'

function PlanUpdates(props) {

    const [updates, setUpdates] = useState([]);

    useEffect(() => {
        (async function () {
            let allChanges = [];
            const auditText = await (await fetch(`/api/algoAudit?planId=` + props.planId)).json();
            if (auditText && Array.isArray(auditText)) {
                auditText.forEach(a => {
                    let description = "";
                    if (a.prev_percentage === 0) description = "Added to plan at " + a.new_percentage + "%";
                    else if (a.new_percentage === 0) description = "Removed from plan (was " + a.prev_percentage + "%)";
                    else description = "Changed allocation from " + a.prev_percentage + "% to " + a.new_percentage + "%";
                    allChanges.push({
                        algoId: a.algoId,
                        display_name: a.display_name,
                        trade_symbol: a.trade_symbol,
                        algo: a.display_name + " (" + a.trade_symbol + ")",
                        date: new Date(a.date),
                        description: description,
                        type: "algo"
                    })
                })
            }

            const configChanges = await (await fetch(`/api/planAlertConfigChanges?planId=` + props.planId)).json();
            if (configChanges && Array.isArray(configChanges)) {
                configChanges.forEach(a => {
                    if (a.prev_config && Object.keys(a.prev_config).length)
                        allChanges.push({
                            algoId: a.algoId,
                            name: a.name,
                            symbol: a.symbol,
                            display_name: a.display_name,
                            trade_symbol: a.trade_symbol,
                            algo: a.display_name + " (" + a.trade_symbol + ")",
                            date: new Date(a.date),
                            description: "Updated configuration",
                            fields: a.updates.map(u => u.key).join(", "),
                            type: "alert"
                        })
                })
            }

            allChanges.sort((a, b) => b.date - a.date)
            setUpdates(allChanges);
        })();
    }, [props.planId]);

    function getAlgoAudit() {
        return updates;
    }


    function algoLinkFormatter(cell, row) {
        return (
            <>
                <Link className="bg-transparent" to={"/algo/" + row.algoId}>{row.display_name}</Link> ({row.trade_symbol})
            </>
        )
    }

    function descriptionFormatter(cell, row) {
        if (row.type === "alert")
            return (
                <>
                    {cell} <Link className="bg-transparent" to={"/configureAlert"} onClick={() => onAlertClicked(row.name, row.symbol)}>(Details)</Link>
                </>
            )
        else
            return (<>{cell}</>)
    }

    async function onAlertClicked(name, symbol) {
        if (props.onAlertSelected) {
            let alert = await (await fetch(`/api/strategyAlertLookup?name=` + name + `&symbol=` + symbol)).json();
            console.log("alert", name, symbol, alert);
            props.onAlertSelected(alert.idtrading_strategy_alerts);
        }
    }

    return (
        <div>
            <RichTable pageSize={15} data={getAlgoAudit()} className="table-striped table-hover table-condensed fixed" mappers={[
                { title: 'Date', field: 'date', formatter: tableHelpers.dateESTFormmatter, sorters: true },
                { title: 'Algo', field: 'algo', formatter: algoLinkFormatter },
                { title: 'Description', field: 'description', sorters: true, formatter: descriptionFormatter },
            ]} />
        </div>
    );
}

export default PlanUpdates;